<script>
import { TabList, TabItem } from './index.js';
import { mapActions, mapState } from 'pinia';
import { orderStore } from '../../../stores/order.js';
import TabContentList from '@/components/order-vue/order/components/tabs/TabContentList.vue';
import TabContent from '@/components/order-vue/order/components/tabs/TabContent.vue';
import FadeInOutTransition from '@/components/order-vue/order/components/transitions/FadeInOutTransition.vue';
import FormCopyField from '@/components/order-vue/order/components/form/form-copy-field.vue';
import OrderFieldString from '@/components/order-vue/order/components/order-fields/order-field-string.vue';

export default {
	components: {
		OrderFieldString,
		FormCopyField,
		FadeInOutTransition,
		TabContent,
		TabContentList,
		TabList,
		TabItem
	},
	
	computed: {
		...mapState(orderStore, [
			'isLoaded',
			'deliverySystems', 
			'currentLocationData', 
			'currentDeliverySystem', 
			'addressFields'
		]),
		
		hasAddressFields() {
			return this.currentDeliverySystem.xmlId !== 'empty' && this.addressFields.length > 0;
		},
		
		currentDelivery() {
			return this.currentDeliverySystem?.id;
		}
	},
	
	methods: {
		...mapActions(orderStore, {
			selectDelivery: 'changeDelivery', 
			selectLocation: 'changeLocation'
		}),
		
		handleTabSelect(delivery) {
			this.selectDelivery(delivery);
		}
	}
};
</script>

<template>
	<TabList v-model:activeTab="currentDelivery" container-class="checkout-item__tabs">
		<TabItem
			v-for="(delivery) in deliverySystems"
			:key="delivery.id"
			:value="delivery.id"
			:active="currentDelivery === delivery.id"
			@select="handleTabSelect(delivery)"
		>
			{{ delivery.name }}
		</TabItem>
	</TabList>
	<TabContentList :class="['checkout-item__content']">
		<input type="hidden" name="DELIVERY_ID" :value="currentDelivery" />
		<FadeInOutTransition>
			<template v-if="hasAddressFields">
				<TabContent
					v-if="currentDelivery"
					:key="currentDelivery"
					:value="currentDelivery"
					:active-tab="currentDelivery"
				>
					
					<div class="checkout-item__form-group">
						<p 
							v-if="currentDeliverySystem.description" 
							class="checkout-item__notice" 
							v-html="currentDeliverySystem.description"
						></p>
						
						<OrderFieldString
							v-for="field in addressFields" 
							:key="field.id"
							:field="field"
							:class="['checkout-item__field']"
						/>
					</div>
				</TabContent>
			</template>
			<template v-else>
				<TabContent
					v-if="currentDelivery"
					:key="currentDelivery"
					:value="currentDelivery"
					:active-tab="currentDelivery"
				>
					<div class="checkout-item__form-group">
						<div class="checkout-item__address-field">
							<span class="checkout-item__address-caption">{{ $loc.get('DELIVERY_PICKUP_ADDRESS_TITLE') }}</span>
							<FormCopyField>
								<template #target>
									<address class="checkout-item__address js-copy-field__value">{{ $loc.get('DELIVERY_PICKUP_ADDRESS') }}</address>
								</template>
								<template #button-content>
									<i class="icon icon-copy"></i>
								</template>
							</FormCopyField>
						</div>
					</div>
				</TabContent>
			</template>
		</FadeInOutTransition>
		
	</TabContentList>
</template>
